import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45b8fc01"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "account-table-component f1 auto",
  ref: "wrapRef",
  style: {"padding-bottom":"50px","position":"relative"}
}
const _hoisted_2 = {
  class: "h100 auto",
  ref: "tabRef"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { key: 6 }
const _hoisted_10 = { key: 7 }
const _hoisted_11 = { key: 8 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除账号")
const _hoisted_14 = { key: 11 }
const _hoisted_15 = { class: "foot-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_EllipsisOutlined = _resolveComponent("EllipsisOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.data,
        scroll: { x: 600 },
        "row-selection": _ctx.rowSelection,
        rowKey: "id",
        size: "middle",
        pagination: false,
        onChange: _ctx.tableChange,
        locale: { filterConfirm: '确定', filterReset: '重置', emptyText: '暂无数据' }
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'defaultServiceDeskName')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.defaultServiceDeskName === 'DEFAULT_SERVICE_DESK_NAME' ? '默认服务台' : record.defaultServiceDeskName), 1))
            : (column.dataIndex === 'user.name')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: '#/system_setting/account-add/detail?id=' + record.id + '&userId=' + record.user.id
                }, _toDisplayString(record.user.name), 9, _hoisted_4))
              : (column.dataIndex === 'user.nickname')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(record.user.nickname || '-'), 1))
                : (column.dataIndex === 'user.status')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.emumStatus[record.user.status]), 1))
                  : (column.dataIndex === 'role.name')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.role.name), 1))
                    : (column.dataIndex === 'user.mobilePhone')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.user.mobilePhone), 1))
                      : (column.dataIndex === 'user.externalId')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(record.user.externalId), 1))
                        : (column.dataIndex === 'user.lastLoginAt')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.user.lastLoginAt), 1))
                          : (column.dataIndex === 'user.email')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(record.user.email), 1))
                            : (column.dataIndex === 'toggle')
                              ? (_openBlock(), _createBlock(_component_a_switch, {
                                  key: 9,
                                  size: "small",
                                  disabled: record.role.nameKey === 'ROLE_NAME_CREATOR' || record.user.status === 2 || !_ctx.hasPermission('engieer_update'),
                                  checked: record.user.status === 1,
                                  onClick: ($event: any) => (_ctx.handleSwitch(record))
                                }, null, 8, ["disabled", "checked", "onClick"]))
                              : (column.dataIndex === 'operation')
                                ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 10 }, {
                                    overlay: _withCtx(() => [
                                      _createVNode(_component_a_menu, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_menu_item, {
                                            onClick: ($event: any) => (_ctx.handleEdit(record))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_12
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          (record.role.nameKey !== 'ROLE_NAME_CREATOR' && _ctx.hasPermission('engieer_delete') && !_ctx.hadSunloginWeb)
                                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.handleDelete(record))
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_13
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_EllipsisOutlined, {
                                        style: {"color":"var(--sys-main-color)","font-size":"20px"},
                                        rotate: 90
                                      })
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(record[column.dataIndex] || '-'), 1))
        ]),
        _: 1
      }, 8, ["columns", "data-source", "row-selection", "onChange"]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_a_pagination, {
          size: "small",
          total: _ctx.total,
          current: _ctx.page.pageNumber,
          defaultPageSize: _ctx.page.pageSize,
          showSizeChanger: "",
          onChange: _ctx.handlePageChange
        }, null, 8, ["total", "current", "defaultPageSize", "onChange"])
      ])
    ], 512)
  ], 512))
}